export default defineNuxtPlugin(async () => {
  const { configP13n } = useFeatureFlags()

  const { gitHash } = useRuntimeConfig().public
  const {
    enableBloomReach,
    bloomReachHost,
    bloomReachEndpointIds,
    bloomReachBasicAuth,
    bloomReachProjectId
  } = configP13n

  let optimizelyCmabMap = {}
  if (configP13n.enableOptimizely) {
    try {
      optimizelyCmabMap = await $fetch('/fapi/optimizely-cmab') || {}
    }
    catch {
      optimizelyCmabMap = {}
    }
  }
  const optimizelyCmabJson = JSON.stringify(optimizelyCmabMap).replace(/</g, '\\u003c')

  useHead(
    {
      link: [
        ...(configP13n.enableOptimizely
          ? [{ href: 'https://cdn.optimizely.com', rel: 'preconnect', tagPriority: 'high' } as any]
          : []
        ),
        ...(bloomReachHost
          ? [{ href: `https://${bloomReachHost}`, rel: 'preconnect', tagPriority: 'high' } as any]
          : []
        )
      ],
      script: [
        {
          innerHTML: `
            window.vfaConfig = {
              siteId: '${useApiHeaders().siteId}',
              bloomReachEndpoint: '${enableBloomReach ? `https://${bloomReachHost}/webxp/s/${bloomReachProjectId}/managed-endpoints/` : ''}',
              bloomReachEndpointIds: ${enableBloomReach ? JSON.stringify(bloomReachEndpointIds) : 'null'},
              bloomReachBasicAuth: '${enableBloomReach ? bloomReachBasicAuth : ''}',
              optimizelySdkKey: '${configP13n.optimizelySdkKey}',
              enableOptimizely: '${configP13n.enableOptimizely}',
              optimizelyCmabMap: ${optimizelyCmabJson}
            }`,
          tagPosition: 'head',
          id: 'vfa-config'
        },
        { src: `/scripts/${gitHash}/prefetch-p13n.js`, type: 'module', fetchpriority: 'high' }
      ],
    },
  )
})
